import { render, staticRenderFns } from "./orderEditor.vue?vue&type=template&id=8e08c604&scoped=true&"
import script from "./orderEditor.vue?vue&type=script&lang=js&"
export * from "./orderEditor.vue?vue&type=script&lang=js&"
import style0 from "./orderEditor.vue?vue&type=style&index=0&id=8e08c604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e08c604",
  null
  
)

export default component.exports